import allServices from "./img/all-services.svg";
import customhw from "./img/customhw.svg";
import customhwKioskOn from "./img/customhw-kiosk-on.svg";
import customhwScreenOffCustomizeOn from "./img/customhw-screen-off-customize-on.svg";
import customhwScreenOffKioskOff from "./img/customhw-screen-off-kiosk-off.svg";
import customhwScreenOffKioskOn from "./img/customhw-screen-off-kiosk-on.svg";
import customhwScreenOn from "./img/customhw-screen-on.svg";
import customhwScreenOnCustomizeOn from "./img/customhw-screen-on-customize-on.svg";
import dataAndFleetAnalytics from "./img/data-and-fleet-analytics.svg";
import dataAndFleetManagement from "./img/data-and-fleet-management.svg";
import dataManagement from "./img/data-management.svg";
import fleetAnalytics from "./img/fleet-analytics.svg";
import fleetManagement from "./img/fleet-management.svg";
import fleetAndFleetAnalytics from "./img/fleet-management-and-fleet-analytics.svg";
import nxp from "./img/nxp.svg";
import nxpKioskOn from "./img/nxp-kiosk-on.svg";
import nxpScreenOffCustomizeOn from "./img/nxp-screen-off-customize-on.svg";
import nxpScreenOffKioskOff from "./img/nxp-screen-off-kiosk-off.svg";
import nxpScreenOffKioskOn from "./img/nxp-screen-off-kiosk-on.svg";
import nxpScreenOn from "./img/nxp-screen-on.svg";
import nxpScreenOnCustomizeOn from "./img/nxp-screen-on-customize-on.svg";
import qualcomm from "./img/qualcomm.svg";
import qualcommKioskOn from "./img/qualcomm-kiosk-on.svg";
import qualcommScreenOffCustomizeOn from "./img/qualcomm-screen-off-customize-on.svg";
import qualcommScreenOffKioskOff from "./img/qualcomm-screen-off-kiosk-off.svg";
import qualcommScreenOffKioskOn from "./img/qualcomm-screen-off-kiosk-on.svg";
import qualcommScreenOn from "./img/qualcomm-screen-on.svg";
import qualcommScreenOnCustomizeOn from "./img/qualcomm-screen-on-customize-on.svg";

export default {
    hardware: {
        nxp,
        nxpScreenOffKioskOff,
        nxpScreenOffKioskOn,
        nxpScreenOffCustomizeOn,
        nxpScreenOn,
        nxpKioskOn,
        nxpScreenOnCustomizeOn,

        qualcomm,
        qualcommScreenOffKioskOff,
        qualcommScreenOffKioskOn,
        qualcommScreenOffCustomizeOn,
        qualcommScreenOn,
        qualcommKioskOn,
        qualcommScreenOnCustomizeOn,

        customhw,
        customhwScreenOffKioskOff,
        customhwScreenOffKioskOn,
        customhwScreenOffCustomizeOn,
        customhwScreenOn,
        customhwKioskOn,
        customhwScreenOnCustomizeOn,
    },

    services: {
        dataManagement,
        fleetManagement,
        fleetAnalytics,
        dataAndFleetManagement,
        dataAndFleetAnalytics,
        fleetAndFleetAnalytics,
        allServices,
    },
};
